import { useTheme } from '@mui/material';

export const EmailIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
            <path
                fill={primaryStroke}
                d="m5.667 11.463 10.335 7.218 10.336-7.219V8.5H5.667v2.963Zm20.671 1.818L16.003 20.5 5.667 13.281V23.5h20.671V13.281ZM4.19 23.5V7h23.625v18H4.19v-1.5Z"
            />
        </svg>
    );
};
